import React from 'react'
import { Card } from '@material-ui/core'
import styled from 'styled-components'
import { media } from '../../theme'
import InputField from '../../components/Form/InputField'
import { FieldT } from '../../components/Form/types'
import Hero from '../../components/Hero'
import { Skeleton } from '@material-ui/lab'

const DetailsCard = styled(Card).attrs({ variant: 'outlined' })`
  margin-top: 16px;
  padding: 16px;
`

const FieldsContainer = styled.div`
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 16px;

  ${media.medium`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${media.small`
    grid-template-columns: auto;
  `}
`

interface Props {
  fieldMaster: {
    [key: string]: FieldT
  }
}

const VoyageForm: React.FC<Props> & { Skeleton: React.FC } = ({ fieldMaster }) => {
  return (
    <Hero backgroundColor='transparent'>
      <DetailsCard>
        <FieldsContainer>
          <InputField of='name' field={fieldMaster['name']} />
          <InputField of='vesselSlug' field={fieldMaster['vesselSlug']} />
        </FieldsContainer>
        <FieldsContainer>
          <InputField of='etd' field={fieldMaster['etd']} />
          <InputField of='eta' field={fieldMaster['eta']} />
        </FieldsContainer>
        <FieldsContainer>
          <InputField of='sourcePortCode' field={fieldMaster['sourcePortCode']} />
          <InputField of='destinationPortCode' field={fieldMaster['destinationPortCode']} />
          <InputField of='shouldFetchEta' field={fieldMaster['shouldFetchEta']} />
        </FieldsContainer>
      </DetailsCard>
    </Hero>
  )
}

const FieldSkeleton = styled(Skeleton).attrs({ variant: 'rect', height: '50px' })``

VoyageForm.Skeleton = () => (
  <>
    <Hero backgroundColor='transparent'>
      <DetailsCard>
        <FieldsContainer>
          <FieldSkeleton />
          <FieldSkeleton />
        </FieldsContainer>
        <FieldsContainer>
          <FieldSkeleton />
          <FieldSkeleton />
        </FieldsContainer>
        <FieldsContainer>
          <FieldSkeleton />
          <FieldSkeleton />
        </FieldsContainer>
      </DetailsCard>
    </Hero>
  </>
)

export default VoyageForm
